import type { StepTask } from '../../types'
import { Field, ReadonlyValue, SectionHeader, getParams } from './fields'
import { ConfigSection } from './ConfigSection'
import { IdvServiceSection } from './IdvServiceSection'
import { OnesdkUtilitySection } from './OnesdkUtilitySection'
import { ConDaonSection } from './ConDaonSection'
import { OneSdkStudio } from './OneSdkStudio'

export interface IdvDrawerProps {
  task: StepTask
  onChange: (updater: (t: StepTask) => StepTask) => void
}

interface PartsForSourceEntry {
  parts: { attestationTypes: string }[]
}

// Portal-style summary label derived from the selected attestations.
function checkTypeLabel(attestations: Set<string>): string {
  const has = (a: string) => attestations.has(a)
  if (has('FACIAL_LIVENESS') && has('FACIAL_COMPARISON') && has('DOCUMENT')) return 'Full Bio'
  if (has('FACIAL_COMPARISON') || has('FACIAL_LIVENESS')) return 'Biometric'
  if (has('DOCUMENT') || has('OCR_COMPARISON')) return 'Document'
  return attestations.size ? 'Custom' : 'None'
}

export function IdvDrawer({ task, onChange }: IdvDrawerProps) {
  const params = getParams(task)
  const minFaceSimilarityScore = (params.minFaceSimilarityScore as number | undefined) ?? 0
  const attestationRequired = Boolean(params.attestationRequired)
  const multipleDocumentsRequired = Boolean(params.multipleDocumentsRequired)

  const partsForSources = (params.partsForSources as PartsForSourceEntry[] | undefined) ?? []
  const selectedAttestations = new Set(partsForSources[0]?.parts.map((p) => p.attestationTypes) ?? [])

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Existing ops center workflow config" />

      <Field label="Check Type">
        <ReadonlyValue>{checkTypeLabel(selectedAttestations)}</ReadonlyValue>
      </Field>

      <Field label="Attestation Required">
        <ReadonlyValue>{String(attestationRequired)}</ReadonlyValue>
      </Field>

      <Field label="Minimum Face Similarity Score">
        <ReadonlyValue>{String(minFaceSimilarityScore)}</ReadonlyValue>
      </Field>

      <Field label="Multiple Documents Required">
        <ReadonlyValue>{String(multipleDocumentsRequired)}</ReadonlyValue>
      </Field>

      <SectionHeader title="Proposed additional config" hint="Mockup · not saved" />
      <p className="text-[10px] text-[#5b6b85] -mt-2">
        Grouped by the config file each setting lives in, so IDV can be set up entirely from here.
      </p>

      <IdvServiceSection />
      <OnesdkUtilitySection />
      <ConDaonSection />
      <ConfigSection title="OneSDK Studio" file="onesdk html">
        <OneSdkStudio task={task} onChange={onChange} />
      </ConfigSection>
    </div>
  )
}
